/**
 * Utility service for reference data
 */
import apiClient from './apiClient';

export const utilityService = {
  /**
   * Get all countries
   * @returns {Promise} List of countries
   */
  getCountries: async () => {
    return apiClient.get('/utility/countries');
  },

  /**
   * Get all nationalities
   * @returns {Promise} List of nationalities
   */
  getNationalities: async () => {
    return apiClient.get('/utility/nationalities');
  },

  /**
   * Get all security questions
   * @returns {Promise} List of security questions
   */
  getSecurityQuestions: async () => {
    return apiClient.get('/utility/security-questions');
  },

  /**
   * Get all timezones
   * @returns {Promise} List of timezones
   */
  getTimezones: async () => {
    return apiClient.get('/utility/timezones');
  },

  /**
   * Get all world timezones
   * @returns {Promise} List of world timezones
   */
  getWorldTimezones: async () => {
    return apiClient.get('/utility/world-timezones');
  },

  /**
   * Get country by phone code
   * @param {string} phoneCode - Phone code (e.g., "+1")
   * @returns {Promise} Country details
   */
  getCountryByPhoneCode: async (phoneCode) => {
    return apiClient.get(`/utility/country/phone-code/${phoneCode}`);
  },

  /**
   * Health check
   * @returns {Promise} Health status
   */
  healthCheck: async () => {
    return apiClient.get('/utility/health');
  }
};

export default utilityService;
